import React from 'react';
import { TabHeader, TabBar } from '@yoti/ui-kit-components-react/tabs';
import styles from './headerTab.module.scss';

interface Props {
    tabs: string[];
    onClick?: (tab: string) => void;
    selected?: string;
    className?: string;
}

const HeaderTab: React.FC<Props> = (props) => {
    const { tabs, selected, onClick, className } = props;
    const selectedTab = selected ? selected : tabs[0];

    const selectHeader = (header: string) => {
        if (onClick) {
            onClick(header);
        }
    };

    return (
        <div className={tabs.length === 1 ? `${styles['single-tab']} ${className}` : className}>
            <TabBar variation="fluid">
                {tabs.map((header, i) => {
                    return (
                        <TabHeader
                            key={i}
                            isSelected={header === selectedTab}
                            onClick={() => selectHeader(header)}
                            title={header}
                            data-qa={`${header.toLowerCase()}-tab-header`}
                        />
                    );
                })}
            </TabBar>
        </div>
    );
};

export default HeaderTab;
